import { combineReducers } from 'redux';
import { get } from 'lodash';
import { AsyncRequest } from 'angieslist-app-platform';
import authActionKeys from 'angieslist-app-platform/lib/common/auth/authActionKeys';
import cookieUtils from 'angieslist-app-platform/lib/common/utils/cookieUtils';
import accountSyncActions from '../../../modules/sync/common/accountSyncActions';

export default combineReducers({
  angiLeadsAccountLinkStatus: AsyncRequest.createReducer(authActionKeys.LOGIN, {
    [authActionKeys.LOGIN_SUCCESS]: (state, action) => {
      const userId = parseInt(get(action, 'payload.body.user.id'), 10);
      const angiLeadsEntityIdFromCookie = cookieUtils.getCookie('entityId');
      const angiLeadsEntityHashCookie = cookieUtils.getCookie('entityHash');
      // just in case we forgot to properly encode things
      const correctedEntityHash = angiLeadsEntityHashCookie.replaceAll(' ', '+');
      if (angiLeadsEntityIdFromCookie && correctedEntityHash && userId) {
        action.addSideEffect(async (store) => {
          /* eslint-disable-next-line max-len */
          await store.dispatch(accountSyncActions.linkAccounts(parseInt(angiLeadsEntityIdFromCookie, 10), userId, correctedEntityHash));
        });
        cookieUtils.deleteCookie('entityId');
        cookieUtils.deleteCookie('entityHash');
      }
      return AsyncRequest.setSuccess(state, { success: true });
    },
  }),
});



// WEBPACK FOOTER //
// ./src/app/common/auth/proAuthReducer.js